// 埋点页面链接：https://stream.jd.com/ddrx/#/requirement/33529
// WARNING!!! 请勿手动修改此文件，如需修改请在子午线平台变更后，执行npm run track-init 33529
import { eventTrackingUtils } from '@/utils/eventTrack/eventTrackingUtils';
export const PageId = Object.freeze({
  Web_Global_Toast_Expo: 'Web_Global_Toast_Expo',
});

interface IPVTrackParamsRecord {
  /** 全局Toast提示组件 */
  Web_Global_Toast_Expo: undefined;
}

const sendPv = {
  /** PV-全局Toast提示组件 */
  Web_Global_Toast_Expo: () => {
    eventTrackingUtils.submitPV({ page_id: PageId.Web_Global_Toast_Expo });
  },
};

interface IExpoTrackParamsRecord {
  /** ChannelPriceFailPopup_Expo */
  M_ChannelPrice_Fail_Popup_Expo: undefined;
}

const EXPOSURE_RECORD: Readonly<Record<keyof IExpoTrackParamsRecord, string>> = Object.freeze({
  /** ChannelPriceFailPopup_Expo */
  M_ChannelPrice_Fail_Popup_Expo: 'M_ChannelPrice_Fail_Popup_Expo',
});

interface IClickTrackParamsRecord {
  /** ChannelPriceFailPopup_Click */
  M_ChannelPrice_Fail_Popup_Click: {
    /** 按钮名称  */
    button_name: string;
  };
}

const sendClickTrack = {
  /** 点击事件上报-ChannelPriceFailPopup_Click */
  M_ChannelPrice_Fail_Popup_Click: (
    json_param: IClickTrackParamsRecord['M_ChannelPrice_Fail_Popup_Click'],
  ) => {
    eventTrackingUtils.submitCL({ event_id: 'M_ChannelPrice_Fail_Popup_Click', json_param });
  },
};

export { EXPOSURE_RECORD, sendClickTrack, sendPv };
export type { IExpoTrackParamsRecord };
